import { render, staticRenderFns } from "./AjoutMonteIABeta.vue?vue&type=template&id=4b11459c&"
import script from "./AjoutMonteIABeta.vue?vue&type=script&lang=js&"
export * from "./AjoutMonteIABeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports